export const ACCEPT_OPT_IN = 'terms/ACCEPT_OPT_IN';
export const COMPLETE_STEP = 'terms/COMPLETE_STEP';
export const DECLINE_OPT_IN = 'terms/DECLINE_OPT_IN';
export const LOCAL_STORAGE_LOADED = 'terms/LOCAL_STORAGE_LOADED';
export const LOCAL_STORAGE_SYNCED = 'terms/LOCAL_STORAGE_SYNCED';
export const SET_TERMS_ACCEPTED = 'terms/SET_TERMS_ACCEPTED';
export const SET_OPT_IN_TERMS_LOADING = 'terms/SET_OPT_IN_TERMS_LOADING';
export const SET_IFRAME_LOADING = 'terms/IFRAME_LOADING';
export const UNDO_OPT_IN = 'terms/UNDO_OPT_IN';
export const VIEW_OPT_IN_TERMS = 'terms/VIEW_OPT_IN_TERMS';

export const localStorageLoaded = data => ({
  type: LOCAL_STORAGE_LOADED,
  data,
});

export const localStorageSynced = () => ({ type: LOCAL_STORAGE_SYNCED });
